import { __awaiter } from "tslib";
import { fetchFromFandomService, getSponsoredWidgetService } from './sponsoredWidgetsService';
import { getAllSponsoredWidgetQueryIds } from 'pathfinder/utils/sponsoredWidgets/getSponsoredWidgetQueryId';
export function getSponsoredWidgetsByWidgetId(widgetType) {
    return __awaiter(this, void 0, void 0, function* () {
        const allPreviewIds = getAllSponsoredWidgetQueryIds();
        const widgetId = allPreviewIds[widgetType];
        if (!widgetId) {
            return null;
        }
        try {
            const widgetsData = yield fetchFromFandomService(widgetType, `campaign-provider/v2/widgets/${widgetId}`);
            return widgetsData ? JSON.parse(widgetsData) : null;
        }
        catch (e) {
            console.error('Error fetching sponsored widgets by widget ID:', e);
            return null;
        }
    });
}
export function getSponsoredWidgetsByDeviceMetadata(widgetType) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const sponsoredWidgetsService = getSponsoredWidgetService();
        const widgets = (_a = (yield sponsoredWidgetsService.getWidgets())) === null || _a === void 0 ? void 0 : _a.filter((value) => value.widgetType === widgetType);
        return widgets;
    });
}
